<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authHeader } from "../../../helpers/auth-header";
import Loading from "@/components/Loading";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";
import SaveButton from "@/components/buttons/save-button";
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        InputGroup,
        SelectGroup,
        SaveButton,
        DatePicker,
        Loading,
    },
    data() {
        const id = this.$route.params.id;
        const modeName = id === 'add' ? 'Add' : 'Edit';

        return {
            id: id,
            title: `Booking ${modeName}`,
            modeName,
            items: [
                {
                    text: "Booking"
                },
                {
                    text: modeName,
                    active: true,
                },
            ],
            data: {
                shopify_id: null,
                customer_firstname: null,
                customer_lastname: null,
                orderItems: [
                    {
                        branch_id: null,
                        product_name: null,
                        product_id: null,
                        sku: null,
                        staff_id: null,
                        booking_date: null,
                        booking_time: null,
                        customer_email: null,
                        shared_at: null,
                        order_id: null,
                        booking_ref: null,
                        redeem_at: null,
                        status: null,
                        timeslotCategoryId: null,
                        request_from: null,
                        has_preferred_staff: 1,
                        remarks: null
                    }
                ],
            },
            branchOptions: [],
            branchBlock: [],
            therapistOptions: [],
            staffBlock: [],
            blockTime: [],
            productOptions: [],
            timeOptions: [],
            stacksOptions: [],
            stacksChecked: [],
            productsData: [],
            statusOptions: [
                { name: 'Ordered', value: 'ordered' },
                { name: 'Booked', value: 'booked' },
                { name: 'Completed', value: 'completed' },
                { name: 'Cancelled', value: 'cancelled' },
                { name: 'Expired', value: 'expired' },
            ],
            selectedDate: null,
            initialStatus: false,
            allowEdit: true,
            bookedTime: '',
            hasBookedTime: false,
            errors: {},

            isLoading: false,
        };
    },
    async created() {
        //
    },
    computed: {
        branchId: {
            get() {
                return this.data.orderItems[0].branch_id;
            },
            set(value) {
                this.data.orderItems[0].branch_id = value;
            }
        },
        staffId: {
            get() {
                return this.data.orderItems[0].staff_id;
            },
            set(value) {
                this.data.orderItems[0].staff_id = value;
            }
        },
        bookingDate: {
            get() {
                return this.data.orderItems[0].booking_date;
            },
            set(value) {
                this.data.orderItems[0].booking_date = value;
                this.updateBookingTimeOptions();
            }
        },
    },
    watch: {
        'data.orderItems.0.staff_id': 'fetchStaffBlocks',
        'data.orderItems.0.product_id': function(newVal) {
            if (newVal && this.productsData.length > 0) {
                const selectedProduct = this.productsData.find(p => p.shopify_product_id === newVal);
                if (selectedProduct) {
                    this.data.orderItems[0].sku = selectedProduct.product_sku;
                    this.data.orderItems[0].product_name = selectedProduct.product_name;
                }
            }
        }
    },
    async mounted() {
        this.retrieveBranches().then((branches) => {
            this.branchOptions = branches.map((branch) => ({
                name: branch.name,
                value: branch.id,
            }));
        });
        
        if (this.modeName !== 'Add') {
            const result = await axios.get(`${process.env.VUE_APP_APIURL}/order/${this.id}`, {
                headers: authHeader(),
            });
            if (result && result.data['code'] === 'success') {
                const order_detail = result.data['data']['order'];

                this.data.shopify_id = order_detail.shopify_id ?? null;
                this.data.customer_firstname = order_detail.customer_firstname ?? null;
                this.data.customer_lastname = order_detail.customer_lastname ?? null;

                const item = result.data['data']['order']['items'][0];
                this.data.orderItems[0].branch_id = item.branch_id;
                this.data.orderItems[0].product_id = item.shopify_product_id;
                this.data.orderItems[0].product_name = item.product_name;
                this.data.orderItems[0].sku = item.sku;
                this.data.orderItems[0].staff_id = item.staff_id;
                this.data.orderItems[0].has_preferred_staff = item.has_preferred_staff;
                this.data.orderItems[0].remarks = item.remarks;
                if (item.booking_at) {
                    this.data.orderItems[0].booking_date = item.booking_at.split(' ')[0];
                    this.data.orderItems[0].booking_time = item.booking_at.split(' ')[1];
                }

                // Pre-select 'booked' in the form when the stored status is 'ordered'
                if (item.status === 'ordered') {
                    this.data.orderItems[0].status = 'booked';
                } else {
                    this.data.orderItems[0].status = item.status;
                }
                this.data.orderItems[0].customer_email = item.customer_email;
                this.data.orderItems[0].shared_at = item.shared_at;
                this.data.orderItems[0].order_id = item.order_id;
                this.data.orderItems[0].booking_ref = item.booking_ref;
                this.data.orderItems[0].redeemed_at = item.redeemed_at;

                // const current = moment();
                // const bookingDateTime = moment(item.booking_at);
                // if (bookingDateTime.isBefore(current)) {
                //     this.allowEdit = false;
                // }

                // if (this.data.orderItems[0].status === 'cancelled' || 
                //     this.data.orderItems[0].status === 'completed' || 
                //     this.data.orderItems[0].status === 'expired') 
                // {
                //     this.allowEdit = false;
                //     this.initialStatus = true;
                // }

                this.stacksOptions = result.data.data.order.stacks_items;
                this.stacksChecked = item.stacks == null ? [] : JSON.parse(item.stacks);
                // console.log(typeof(this.stacksChecked));
                

                this.retrieveBranchesOfProduct(item.product_id).then((branches) => {
                    this.branchOptions = branches.map((branch) => ({
                        name: branch.name,
                        value: branch.id,
                    }));
                });

                this.updateProductTherapistOptions();
                // this.fetchTherapist(this.data.orderItems[0].product_id);
                this.updateBookingTimeOptions();
            }
        }
    },
    methods: {
        showConfirmationSequence(messages, onComplete) {
            const showNext = (index) => {
                if (index >= messages.length) {
                    onComplete();
                    return;
                }

                this.$refs.confirmationModal.showModal(
                    messages[index],
                    () => {
                        this.$refs.confirmationModal.closeModal();
                        showNext(index + 1);
                    }
                );
            };

            showNext(0);
        },
        async updateProductTherapistOptions() {
            if (this.modeName === 'Add') {
                this.data.orderItems[0].product_id = null;
                this.data.orderItems[0].product_name = null;
                this.data.orderItems[0].staff_id = null;
                this.data.orderItems[0].booking_date = null;
                this.data.orderItems[0].booking_time = null;
            }

            if (this.data.orderItems[0].branch_id) {
                this.retrieveProducts(this.data.orderItems[0].branch_id);
                this.fetchBranchBlocks(this.data.orderItems[0].branch_id);
            }
        },
        
        async updateBookingTimeOptions() {
            if (this.modeName === 'Add') {
                this.data.orderItems[0].booking_time = null;
            }

            if (this.data.orderItems[0].branch_id && this.data.orderItems[0].booking_date && this.data.orderItems[0].product_id) {
                const isWeekend = this.isWeekend(this.data.orderItems[0].booking_date) ? 1 : 0;
                this.fetchTimeslots(this.data.orderItems[0].branch_id, this.data.orderItems[0].product_id, isWeekend);
            }
        },

        async fetchStaffBlocks(staffId) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_APIURL}/stafftimeslot/${staffId}`, {
                    headers: authHeader(),
                });

                if (result && result.data['code'] === 'success') {
                    if (result.data['data']['staffTimeslots'].length > 0) {
                        for (const off of result.data['data']['staffTimeslots']) {
                            if (off.booking_at) {
                                const [date, time] = off.booking_at.split(' ');
                                const formattedTime = time.substring(0, time.length - 3);

                                const duration = off.total_duration;
                                const formattedTimeParts = formattedTime.split(':');
                                const hours = parseInt(formattedTimeParts[0], 10);
                                const minutes = parseInt(formattedTimeParts[1], 10);

                                // Add the duration to the time
                                const newMinutes = minutes + duration;
                                const newHours = hours + Math.floor(newMinutes / 60);
                                const updatedMinutes = newMinutes % 60;

                                // Format the new time
                                const endTime = `${newHours.toString().padStart(2, '0')}:${updatedMinutes.toString().padStart(2, '0')}`;

                                this.blockTime.push({ date: date, start: formattedTime, end: endTime });
                            }
                        }
                    }
                }
            } catch (e) {
                console.error('Error fetching branch blocks: ' + e);
            }

            // try {
            //     const result = await axios.get(`${process.env.VUE_APP_APIURL}/staff-block/${staffId}`, {
            //         headers: authHeader(),
            //     });

            //     if (result && result.data['code'] === 'success') {
            //         if (result.data['data']['staffBlock'].length > 0) {
            //             this.staffBlock = [];
            //             for (const offDate of result.data['data']['staffBlock']) {
            //                 if (offDate.start === null && offDate.end === null) {
            //                     this.staffBlock.push(offDate.date);
            //                 } else {
            //                     this.blockTime.push({ date: offDate.date, start: offDate.start, end: offDate.end });
            //                     console.log('ccc', this.blockTime)
            //                 }
            //             }
            //         }
            //     }
            // } catch (e) {
            //     console.error('Error fetching staff blocks: ' + e);
            // }
        },

        async fetchBranchBlocks(branchId) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_APIURL}/branchblock/${branchId}`, {
                    headers: authHeader(),
                });

                if (result && result.data['code'] === 'success') {
                    if (result.data['data']['branchBlock'].length > 0) {
                        this.branchBlock = [];
                        this.blockTime = [];
                        for (const offDate of result.data['data']['branchBlock']) {
                            if (offDate.start === null && offDate.end === null) {
                                this.branchBlock.push(offDate.date);
                            } else {
                                this.blockTime.push({ date: offDate.date, start: offDate.start, end: offDate.end });
                            }
                        }
                    }
                }
            } catch (e) {
                console.error('Error fetching branch blocks: ' + e);
            }
        },

        async fetchTimeslots(branchId, productId, isWeekend) {
            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/product-timeslot/${productId}`, {
                    headers: authHeader(),
                    params: {
                        branch_id: branchId,
                        isWeekend: isWeekend,
                        selectedDate: this.data.orderItems[0].booking_date,
                        selectedStaff: this.data.orderItems[0].staff_id,
                    },
                });

                const result = await item.data;
                if (result && result['code'] === 'success') {
                    const timeslots = JSON.parse(result.data.timeslots[0]['timeslots']);
                    const product_timeslots = JSON.parse(result.data.timeslots[0]['product_timeslot']);
                    if (product_timeslots && Object.keys(product_timeslots).length > 0) {
                        this.timeOptions = Object.entries(product_timeslots)
                            .filter(([key]) => (isWeekend ? key.startsWith("weekend_") : key.startsWith("weekday_")))
                            .map(([, value]) => ({
                                name: value,
                                value: value,
                        }));
                    } else {
                        this.timeOptions = Object.entries(timeslots)
                            .filter(([key]) => (isWeekend ? key.startsWith("weekend_") : key.startsWith("weekday_")))
                            .map(([, value]) => ({
                                name: value,
                                value: value,
                        }));
                    }

                    if (this.blockTime) {
                        this.timeOptions = this.timeOptions.filter((timeOption) => {
                            return !this.blockTime.some((block) => {
                                if (this.data.orderItems[0].booking_date == block.date) {
                                    const blockStart = block.start;
                                    const blockEnd = block.end;
                                    const timeValue = timeOption.value;

                                    return (
                                        timeValue >= blockStart && timeValue <= blockEnd
                                    );
                                }
                            });
                        });
                    }
                    
                    if (this.data.orderItems[0].booking_time != null) {
                        let bookedTime = this.data.orderItems[0].booking_time;
                        if (!this.timeOptions.some(e => e.name === bookedTime)) {
                            this.timeOptions.push({"name": bookedTime, "value": bookedTime});
                            this.bookedTime = bookedTime;
                            this.hasBookedTime = true;
                        }
                    }
                }
            } catch (e) {
                console.error('Error fetching Timeslots: ' + e);
            }
        },

        isWeekend(dateString) {
            const selectedDate = new Date(dateString);
            const dayOfWeek = selectedDate.getDay();
            return dayOfWeek === 0 || dayOfWeek === 6;
        },

        async retrieveBranches() {
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    const branchesDetails = result['data'].branches;
                    branches = branchesDetails.filter(branch => branch.status == 1);
                }
            } catch (e) {
                console.error(e);
            }

            return branches;
        },

        async retrieveBranchesOfProduct(productId) {
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/product-branches/${productId}`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    const branchesDetails = result['data'].branches;
                    branches = branchesDetails.filter(branch => branch.status == 1);
                }
            } catch (e) {
                console.error(e);
            }

            return branches;
        },

        async retrieveProducts(branchId) {
            let product_staff = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/product-branch/${branchId}`, {
                    headers: authHeader(),
                    params: {
                        product_id: this.data.orderItems[0].product_id ?? 0,
                    },
                });
console.log('pid', this.data.orderItems[0].product_id);
                const result = await item.data;
                if (result['code'] === 'success') {
                    product_staff = result['data'].product_branch;
console.log(product_staff);
                    this.productsData = product_staff;
                    if (product_staff.length > 0) {                        
                        const uniqueProductIds = new Set();
                        this.productOptions = product_staff.filter((product) => {
                            if (!uniqueProductIds.has(product.shopify_product_id)) {
                                uniqueProductIds.add(product.shopify_product_id);
                                return true;
                            }
                            return false;
                        }).map((product) => ({
                            name: product.product_name,
                            value: product.shopify_product_id,
                        }));

                        const uniqueStaffIds = new Set();
                        this.therapistOptions = product_staff.filter((staff) => {
                            if (!uniqueStaffIds.has(staff.staff_id)) {
                                uniqueStaffIds.add(staff.staff_id);
                                return true;
                            }
                            return false;
                        }).map((staff) => ({
                            name: staff.staff_name,
                            value: staff.staff_id,
                        }));

                        var productStaffData = product_staff;
                        const selectedProduct = productStaffData.find(
                            (product) => product.shopify_product_id === this.data.orderItems[0].product_id
                        );
                        if (selectedProduct) {
                            console.log('selectedProduct', selectedProduct);
                            this.data.orderItems[0].sku = selectedProduct.product_sku;
                        }                        
                    } else {
                        this.therapistOptions = [];
                        console.log('no staff found for this product');
                    }
                }
            } catch (e) {
                console.error('Error fetching product_staff: ' + e);
            }

            return product_staff;
        },

        async save() {
            this.isLoading = true;
            this.errors = {};

            this.data.request_from = 'admin';
            this.data.orderItems[0].id = this.id;
            this.data.orderItems[0].stacks = null;

            if (typeof(this.stacksChecked) === 'boolean') {
                let stackValue = [this.stacksOptions[0].id];
                this.data.orderItems[0].stacks = this.stacksChecked ? stackValue : null;
            } else {
                // console.log(this.stacksChecked.length);
                if (this.stacksChecked != null) {
                    this.data.orderItems[0].stacks = this.stacksChecked.length === 0 ? null : this.stacksChecked;
                }
            }
            
            if (this.modeName === 'Add') {
                this.data.orderItems[0].status = 'booked';
            }

            const requestData = JSON.parse(JSON.stringify(this.data));

            let conflictCheckingResult = await axios.post(`${process.env.VUE_APP_APIURL}/order/validate`, requestData, {
                headers: authHeader(),
            });

            // Collect warnings
            const warnings = [];

            if (conflictCheckingResult.data.conflict_detected) {
                warnings.push('Booking conflict detected. Confirm to proceed?');
            }

            if (conflictCheckingResult.data.block_conflict_detected) {
                if (conflictCheckingResult.data.block_conflict_type === 'staff') {
                    warnings.push('Selected staff is blocked for this time. Confirm to proceed?');
                }

                if (conflictCheckingResult.data.block_conflict_type === 'branch') {
                    warnings.push('Branch is blocked for this time. Confirm to proceed?');
                }
            }

            if (conflictCheckingResult.data.invalid_customer_email) {
                warnings.push('Customer email is not registered in Shopify. Confirm to proceed?');
            }

            // If conflict detected or invalid customer email, show modal and only proceed on confirm
            // if (conflictCheckingResult.data['conflict_detected'] || 
            //     conflictCheckingResult.data['invalid_customer_email'] ||
            //     conflictCheckingResult.data['block_conflict_detected']) {
                
            //     this.isLoading = false;
                
            //     // Build the message based on both conditions
            //     let message = '';
            //     if (conflictCheckingResult.data['conflict_detected'] && conflictCheckingResult.data['invalid_customer_email'] && conflictCheckingResult.data['block_conflict_detected']) {

            //         message = 'Block date AND booking conflict detected AND customer email is not registered in Shopify. Confirm to proceed?';
            //     } else if (conflictCheckingResult.data['conflict_detected'] && conflictCheckingResult.data['invalid_customer_email']) {

            //         message = 'Booking conflict detected AND customer email is not registered in Shopify, confirm to proceed?';
            //     } else if (conflictCheckingResult.data['invalid_customer_email'] && conflictCheckingResult.data['block_conflict_detected']) {

            //         message = 'Block date conflict detected and customer email is not registered in Shopify, confirm to proceed?';
            //     } else if (conflictCheckingResult.data['conflict_detected'] && conflictCheckingResult.data['block_conflict_detected']) {

            //         message = 'Block date AND booking conflict detected, confirm to proceed?';
            //     } else if (conflictCheckingResult.data['block_conflict_detected']) {

            //         message = 'Block date conflict detected, confirm to proceed?';
            //     } else if (conflictCheckingResult.data['conflict_detected']) {

            //         message = 'Booking conflict detected, confirm to proceed?';
            //     } else if (conflictCheckingResult.data['invalid_customer_email']) {

            //         message = 'Customer email is not registered in Shopify. Confirm to proceed?';
            //     }

            //     const proceedCallback = async () => {
            //         this.isLoading = true;
            //         this.$refs.confirmationModal.closeModal();

            //         let result;
            //         if (this.modeName === 'Add') {
            //             result = await axios.post(`${process.env.VUE_APP_APIURL}/order`, requestData, {
            //                 headers: authHeader(),
            //             });
            //         } else {
            //             result = await axios.put(`${process.env.VUE_APP_APIURL}/order/${this.id}`, requestData, {
            //                 headers: authHeader(),
            //             });
            //         }

            //         this.handleResult(result);
            //     };

            //     this.$refs.confirmationModal.showModal(message, proceedCallback);
            //     return;
            // }

            // If any warning exists, show sequential modals
            if (warnings.length > 0) {
                this.isLoading = false;

                this.showConfirmationSequence(warnings, async () => {
                    this.isLoading = true;

                    let result;
                    if (this.modeName === 'Add') {
                        result = await axios.post(
                            `${process.env.VUE_APP_APIURL}/order`,
                            requestData,
                            { headers: authHeader() }
                        );
                    } else {
                        result = await axios.put(
                            `${process.env.VUE_APP_APIURL}/order/${this.id}`,
                            requestData,
                            { headers: authHeader() }
                        );
                    }

                    this.handleResult(result);
                });

                return;
            }

            // If no conflict, proceed as normal
            let result;
            if (this.modeName === 'Add') {
                result = await axios.post(`${process.env.VUE_APP_APIURL}/order`, requestData, {
                    headers: authHeader(),
                });
            } else {
                result = await axios.put(`${process.env.VUE_APP_APIURL}/order/${this.id}`, requestData, {
                    headers: authHeader(),
                });
            }

            this.handleResult(result);
        },
        handleResult(result) {
            this.isLoading = false;

            if (!result) return;

            if (result.data['code'] === 'success') {
                if (this.modeName === 'Add') {
                    this.$router.back();
                } else {
                    this.$refs.messageModal.showModal('Your record has been updated successfully');
                }
            } else if (result.data['code'] === 'invalid_field') {
                this.errors = result.data['errors'];
            } else if (result.data['code'] === 'invalid_status') {
                this.$refs.messageModal.showModal(
                    'The current status is already either completed, cancelled or expired!'
                );
            } else if (result.data['code'] === 'reach_max_slot') {
                this.$refs.messageModal.showModal(
                    `The treatment has reached its limit for ${this.data.orderItems[0].booking_date}. Please try different date or branch`
                );
            } else if (result.data['code'] === 'invalid_date') {
                this.$refs.messageModal.showModal(
                    'The booking time has passed, only status is editable.'
                );
            }
        },
        disableDates(date) {
            const val = moment(date);
            const today = moment();

            if (val.isBefore(today, 'day')) {
                return true;
            }

            // if (this.staffBlock || this.branchBlock) {
            //     const isBranchBlockDate = this.branchBlock.some((offDay) => moment(offDay).isSame(val, 'day'));
            //     const isStaffBlockDate = this.staffBlock.some((offDay) => moment(offDay).isSame(val, 'day'));

            //     return isBranchBlockDate || isStaffBlockDate;
            // }
            // return false;
        },

        handleBranchChange() {
            this.data.orderItems[0].staff_id = null;
            this.data.orderItems[0].booking_date = null;
            this.data.orderItems[0].booking_time = null;
            
            this.updateProductTherapistOptions();
            this.retrieveProducts(this.data.orderItems[0].branch_id);
        },

        handleProductChange() {
            this.data.orderItems[0].staff_id = null;
            this.data.orderItems[0].booking_date = null;
            this.data.orderItems[0].booking_time = null;

            // this.fetchTherapist(this.data.orderItems[0].product_id);
            this.retrieveProducts(this.data.orderItems[0].branch_id);
        },

        handleTherapistChange() {
            this.data.orderItems[0].booking_date = null;
            this.data.orderItems[0].booking_time = null;
        },

        handleDateChange() {
            this.data.orderItems[0].booking_time = null;
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" title="WARNING" />
        <MessageModal ref="messageModal" />
        <Loading v-if="isLoading" />
        <div class="card p-3">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                    <SelectGroup id="branch_id" displayName="Branch*" v-model="branchId" :options="branchOptions" @input="handleBranchChange" :error="errors[`orderItems.0.branch_id`]" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <SelectGroup id="treatment" displayName="Treatment*" v-model="data.orderItems[0].product_id" :options="productOptions" @input="handleProductChange" :error="errors[`orderItems.0.product_id`]" />
                    <!-- <InputGroup type="text" v-else :readOnly="true" id="treatment" displayName="Treatment" v-model="data.orderItems[0].product_name" /> -->
                </div>
                <div class="col-12 col-md-6 col-lg-4" v-if="this.modeName !== 'Add'">
                    <InputGroup :readOnly="true" type="text" id="sku" displayName="SKU*" v-model="data.orderItems[0].sku" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <label class="mb-3 d-block w-100">Has preferred therapist?*</label>
                    <div class="d-flex radio">
                        <input type="radio" id="yes" value="1" name="has_preferred_staff" role="button" v-model="data.orderItems[0].has_preferred_staff">
                        <label class="mb-0 ml-2 mr-3" for="yes" role="button">Yes</label>
                        <input type="radio" class="ml-5" id="no" value="0" name="has_preferred_staff" role="button" v-model="data.orderItems[0].has_preferred_staff">
                        <label class="mb-0 ml-2 mr-3" for="no" role="button">No</label>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <SelectGroup id="therapist" displayName="Therapist*" v-model="data.orderItems[0].staff_id" :options="therapistOptions" @input="handleTherapistChange" :error="errors[`orderItems.0.staff_id`]" />
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <label for="booking_date">Booking Date*</label>
                    <date-picker
                        v-model="bookingDate"
                        :default-value="new Date()"
                        :min-date="new Date()"
                        valueType="format"
                        :editable="false"
                        @input="handleDateChange"
                    ></date-picker>
                    <div class="alert alert-danger mt-3" role="alert" v-if="errors[`orderItems.0.booking_date`] && errors[`orderItems.0.booking_date`].length > 0">
                        {{ errors[`orderItems.0.booking_date`][0] }}
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <label for="booking_time">Booking Time*</label>
                    <input type="time" class="form-control" v-model="data.orderItems[0].booking_time" id="booking_time">
                    <!-- <select class="form-control" v-model="data.orderItems[0].booking_time" id="booking_time" :disabled="!allowEdit" :style="!allowEdit ? 'opacity: 0.6;' : ''">
                        <option v-for="option in timeOptions" :key="option.value" :value="option.value" :disabled="option.value == bookedTime && hasBookedTime">{{ option.name }}</option>
                    </select> -->
                    <div class="alert alert-danger mt-3" role="alert" v-if="errors[`orderItems.0.booking_time`] && errors[`orderItems.0.booking_time`].length > 0">
                        {{ errors[`orderItems.0.booking_time`][0] }}
                    </div>
                </div>

                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="text" id="customer_firstname" displayName="Customer First Name*" v-model="data.customer_firstname" :error="errors[`customer_firstname`]" />                
                </div>

                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="text" id="customer_lastname" displayName="Customer Last Name*" v-model="data.customer_lastname" :error="errors[`customer_lastname`]" />                
                </div>

                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="email" id="customer_email" displayName="Customer Email*" v-model="data.orderItems[0].customer_email" :error="errors[`orderItems.0.customer_email`]" />                
                </div>

                <div class="col-12 col-md-6 col-lg-4" v-if="this.modeName !== 'Add'">
                    <InputGroup v-if="this.initialStatus" :readOnly="true" type="text" id="status" displayName="Status" v-model="data.orderItems[0].status"/>
                    <SelectGroup v-else id="status" displayName="Status*" v-model="data.orderItems[0].status" :options="statusOptions" />
                    <div class="alert alert-danger mt-3" role="alert" v-if="errors[`orderItems.0.status`] && errors[`orderItems.0.status`].length > 0">
                        {{ errors[`orderItems.0.status`][0] }}
                    </div>
                </div>

                <div class="col-12 col-md-6 col-lg-4">
                    <InputGroup type="textarea" id="remarks" displayName="Remarks" v-model="data.orderItems[0].remarks" :error="errors[`orderItems.0.remarks`]" />
                </div>

                <div class="col-12" v-if="stacksOptions.length > 0">
                    <h6 class="m-0 font-weight-bold">Booking Stacks with:</h6>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox m-0 mb-2" v-for="item in stacksOptions" :key="item.id">
                            <input type="checkbox" class="custom-control-input" :value="item.id" :id="item.id" v-model="stacksChecked">
                            <label class="custom-control-label" :for="item.id">({{ data.orderItems[0].order_id }}) {{ item.product_name }} - {{ item.booking_ref }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="row" > -->
                
            <!-- </div> -->
            
            <div v-if="this.modeName !== 'Add'">
                <!-- <h6 class="m-0 font-weight-bold">Customer Email:</h6>
                <p class="mb-3">{{ data.orderItems[0].customer_email }}</p> -->

                <h6 class="m-0 font-weight-bold">Shopify Order ID:</h6>
                <p class="mb-3">{{ data.shopify_id ?? '-'}}</p>

                <h6 class="m-0 font-weight-bold">Booking ID:</h6>
                <p class="mb-3">{{ data.orderItems[0].order_id }}</p>

                <h6 class="m-0 font-weight-bold">Booking Code:</h6>
                <p class="mb-3">{{ data.orderItems[0].booking_ref }}</p>

                <h6 class="m-0 font-weight-bold">Shared:</h6>
                <p class="mb-3">{{ data.orderItems[0].shared_at ? 'Yes' : 'No' }}</p>

                <!-- <h6 class="m-0 font-weight-bold">Redeem Date:</h6>
                <p class="mb-3">{{ data.orderItems[0].redeemed_at ?? '-' }}</p> -->
            </div>

            <div class="row mt-2">
                <div class="col-12">
                    <SaveButton @click="save" />
                </div>
            </div>
        </div>
    </Layout>
</template>